export default __webpack_public_path__ + "static/blue-graph-paper-2cbe9c2ecdd32623649e4c9130524946.jpg";